<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('languages.create_language') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.language') }} <strong>{{ language.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-language-new *ngIf="newMode()"></app-language-new>
            <app-language-basedata *ngIf="editMode()" [language]="language"></app-language-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
